import React from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../../../components/AppIcon';
import AppImage from '../../../components/AppImage';

const BlogCard = ({ post, featured = false }) => {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate(`/blog/${post?.slug}`);
  };

  return (
    <article
      onClick={handleClick}
      className={`group cursor-pointer bg-card border border-border rounded-lg overflow-hidden hover:shadow-lg transition-smooth ${
        featured ? 'lg:flex lg:flex-row' : 'flex flex-col'
      }`}
    >
      {/* Image */}
      <div className={`relative overflow-hidden ${
        featured ? 'lg:w-1/2' : 'w-full'
      }`}>
        <AppImage
          src={post?.image}
          alt={post?.alt}
          className="w-full h-64 object-cover group-hover:scale-105 transition-transform duration-300"
        />
        <div className="absolute top-4 left-4">
          <span className="px-3 py-1 bg-primary text-primary-foreground text-xs font-semibold rounded-full">
            {post?.category?.split('-')?.map(word => word?.charAt(0)?.toUpperCase() + word?.slice(1))?.join(' ')}
          </span>
        </div>
      </div>

      {/* Content */}
      <div className={`p-6 flex flex-col ${
        featured ? 'lg:w-1/2' : 'flex-1'
      }`}>
        <div className="flex items-center gap-4 text-sm text-muted-foreground mb-3">
          <div className="flex items-center gap-1">
            <Icon name="Calendar" size={14} />
            <span>{post?.date}</span>
          </div>
          <div className="flex items-center gap-1">
            <Icon name="Clock" size={14} />
            <span>{post?.readTime}</span>
          </div>
        </div>

        <h3 className={`font-bold text-foreground mb-3 group-hover:text-primary transition-smooth ${
          featured ? 'text-2xl' : 'text-xl'
        }`}>
          {post?.title}
        </h3>

        <p className="text-muted-foreground mb-4 flex-1">
          {post?.excerpt}
        </p>

        <div className="flex items-center justify-between pt-4 border-t border-border">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 bg-gradient-to-br from-primary to-secondary rounded-full flex items-center justify-center">
              <span className="text-white font-semibold text-sm">
                {post?.author?.split(' ')?.map(n => n?.[0])?.join('')}
              </span>
            </div>
            <div>
              <p className="text-sm font-medium text-foreground">{post?.author}</p>
              <p className="text-xs text-muted-foreground">{post?.authorRole}</p>
            </div>
          </div>

          <Icon
            name="ArrowRight"
            size={20}
            className="text-primary group-hover:translate-x-1 transition-transform"
          />
        </div>
      </div>
    </article>
  );
};

export default BlogCard;